import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import baseUrl from "../../../../helper/api";
import axios from "../../../../api/axios";

const initialState = {
  rcs: [],
  isLoading: null,
  status: null,
};

const token = userObj?.token;

export const getRcs = createAsyncThunk(
  "order/getRcs",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/Order/rcs/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (err) {
      console.log(err.response);
      return rejectWithValue(err.response.data.title);
    }
  }
);

const getRcsSlice = createSlice({
  name: "getRcs",
  initialState,
  reducers: {},
  extraReducers: {
    [getRcs.pending]: (state, action) => {
      state.status = "pending";
      state.isLoading = true;
    },
    [getRcs.fulfilled]: (state, action) => {
      state.status = "success";
      state.isLoading = false;
      state.rcs = action.payload;
      // localStorage.setItem('user', JSON.stringify(action.payload))
    },

    [getRcs.rejected]: (state, action) => {
      state.status = "failed";
      state.isLoading = false;
    },
  },
});

export default getRcsSlice.reducer;
